import { NotifyHelper } from "../../../helpers/toast";
import { objMonAnChiTietDefine } from "../../action-types/thuc-don/IFoMonAnChiTietActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const foMonAnChiTietActions = {
    ...generateActions(objMonAnChiTietDefine, "MON_AN_CHI_TIET"),
    ...generateActionForKey(objMonAnChiTietDefine, "MON_AN_CHI_TIET",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objMonAnChiTietDefine, "MON_AN_CHI_TIET",
        "LOAD_COSO_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objMonAnChiTietDefine, "MON_AN_CHI_TIET",
        "LOAD_COSO_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objMonAnChiTietDefine, "MON_AN_CHI_TIET",
        "SAVE_SUCCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objMonAnChiTietDefine, "MON_AN_CHI_TIET",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objMonAnChiTietDefine, "MON_AN_CHI_TIET",
        "DELETE_SUCCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objMonAnChiTietDefine, "MON_AN_CHI_TIET",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
